import { CssBaseline } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { BacheloretteParty, FAQPage, Home, Journey } from "./pages";
import "./App.css";

export const App = (): JSX.Element => (
  <HelmetProvider>
    <CssBaseline />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/journey" element={<Journey />} />
        <Route path="/bachelorette-party" element={<BacheloretteParty />} />
        <Route path="/faq" element={<FAQPage />} />
      </Routes>
    </BrowserRouter>
  </HelmetProvider>
);
